{
  "errorFallback": {
    "message": "This block couldn’t be displayed."
  },
  "emptyState": {
    "clickPencilAbove": "<text>Click</text><pencil/><text>above</text><arrow/>",
    "doubleClickToEdit": "Double click to edit"
  },
  "iframeGate": {
    "clickToInteract": "Click to interact"
  },
  "grip": {
    "title": "Drag to move · Right-click for menu"
  },
  "toolbar": {
    "openInWindow": "Open in a window"
  },
  "noleBead": {
    "editedByNole": "Edited by Nolë",
    "writing": "Writing…",
    "reading": "Reading…",
    "done": "Done"
  },
  "displayOptions": {
    "showTitle": "Show title",
    "scaleWithZoom": "Scale with zoom",
    "collapsibleSections": "Collapsible sections"
  },
  "extraction": {
    "filling": "Filling…",
    "failed": "The fields couldn’t be filled.",
    "couldNotFill": "Couldn’t fill",
    "dismissTitle": "{{message}}\nClick to dismiss.",
    "dismissFailed": "Could not dismiss the error"
  },
  "custom": {
    "unknownTemplate": "Unknown template"
  },
  "edit": {
    "editFile": "Edit file",
    "editAppTitle": "Edit app title",
    "editLink": "Edit link",
    "titleOptional": "Title (optional)",
    "title": "Title",
    "linkTitleFetchFailed": "Unable to fetch page title",
    "linkUrlPlaceholder": "URL or <iframe> embed code…",
    "renameOrReplace": "Rename or replace",
    "addFile": "Add a file",
    "fileName": "File name",
    "imageFallbackName": "image",
    "extractToNewNode": "Extract to a new node",
    "splitAll_one": "Split all ({{count}})",
    "splitAll_other": "Split all ({{count}})",
    "addImages": "Add images",
    "manageImages": "Manage images",
    "library": "Library",
    "manageVideo": "Edit video",
    "file": "File",
    "generate": "Generate"
  },
  "image": {
    "empty": "No image",
    "defaultName": "Image",
    "generate": "Generate",
    "altIndexed": "Image {{index}}",
    "generationStartFailed": "Could not start the generation",
    "launchGeneration": "Launch image generation",
    "generating": "Generating…",
    "generatedWith": "Generated with {{model}}"
  },
  "value": {
    "edit": "Edit value",
    "value": "Value",
    "yes": "Yes",
    "no": "No",
    "number": "Number",
    "text": "Text",
    "optionsOptional": "Options (optional)",
    "type": "Type",
    "yesNo": "Yes/No",
    "unitOptional": "Unit (optional)",
    "unitPlaceholder": "kg, $, %…",
    "labelOptional": "Label (optional)",
    "label": "Label",
    "empty": "No value"
  },
  "file": {
    "empty": "No file"
  },
  "blocknote": {
    "fallbackTitle": "Blocknote",
    "markdownConversionFailed": "Could not convert this document to Markdown",
    "downloadAsMarkdown": "Download as Markdown"
  },
  "link": {
    "empty": "No link",
    "copied": "Link copied to clipboard",
    "copyFailed": "Unable to copy link",
    "copyLink": "Copy link",
    "copyLinkUrl": "Copy link URL",
    "refreshEmbed": "Refresh embed",
    "embeddedContent": "Embedded content"
  },
  "app": {
    "fallbackTitle": "App",
    "refresh": "Refresh app",
    "refreshLabel": "Refresh",
    "downloadCode": "Download code",
    "empty": "No app",
    "emptyHint": "Ask Nolë to code something"
  },
  "table": {
    "fallbackTitle": "Table",
    "visibleOfTotal": "{{shown}} of {{total}}"
  },
  "database": {
    "fallbackTitle": "Database",
    "addTo": "Add to {{title}}",
    "empty": "No rows yet",
    "emptyHint": "Double-click the title to open it",
    "previewCount_one": "{{shown}} of {{total}} row",
    "previewCount_other": "{{shown}} of {{total}} rows",
    "row": "Row",
    "addRow": "Add a row"
  },
  "databaseView": {
    "fallbackName": "View",
    "renameFailed": "Could not rename the view",
    "databaseMissing": "Its database is in the trash or on another canvas"
  },
  "transcribe": {
    "running": "Transcribing…",
    "runningProgress": "Transcribing… {{done}}/{{total}}",
    "runningTitle": "Transcription in progress — you can keep working",
    "transcript": "Transcript",
    "openTranscript": "Open the transcript",
    "transcribe": "Transcribe",
    "tooLarge": "File too large to transcribe",
    "tooLargeWithMax": "File too large to transcribe (max {{max}} MB)",
    "failed": "Transcription failed: {{error}}. Click to retry.",
    "unknownError": "unknown error",
    "idleTitleAudio": "Transcribe this audio to make its content searchable",
    "idleTitleVideo": "Transcribe this video to make its content searchable"
  },
  "media": {
    "playbackSpeed": "Playback speed",
    "mute": "Mute",
    "unmute": "Unmute",
    "volume": "Volume",
    "play": "Play",
    "pause": "Pause",
    "backToStart": "Back to start",
    "clearLoop": "Clear loop",
    "loopStartHere": "Start the loop here",
    "loopEndHere": "End the loop here",
    "loopOff": "Turn the loop off",
    "loopOn": "Turn the loop on",
    "loopSetFirst": "Set a start and an end first",
    "noAudio": "No audio",
    "noVideo": "No video",
    "formatUnsupported": "This browser cannot play this format.",
    "downloadFile": "Download the file"
  },
  "headingLevels": {
    "h1": "Heading 1",
    "h2": "Heading 2",
    "h3": "Heading 3",
    "p": "Text"
  },
  "title": {
    "placeholder": "Click to edit…",
    "style": "Style",
    "width": "Width",
    "autoFitWidth": "Auto-fit width",
    "autoFitWidthTitle": "Auto-fit width to text",
    "titleSize": "Title size"
  },
  "nodeCount": {
    "empty": "Empty",
    "nodes_one": "{{count}} node",
    "nodes_other": "{{count}} nodes"
  },
  "frame": {
    "untitled": "Untitled frame"
  },
  "board": {
    "editLayout": "Edit layout",
    "untitled": "Untitled board",
    "invalidLayout": "Invalid board layout",
    "emptyText": "Empty text",
    "rootLabel": "Board",
    "leafKinds": {
      "space": "Space",
      "text": "Text",
      "divider": "Divider"
    },
    "spaceFallbackName": "Space {{rank}}",
    "spaceNameHint": "The name is only shown in this editor.",
    "spaceNameHintWithNodes_one": "The name is only shown in this editor. Deleting this space moves its {{count}} node to the first space.",
    "spaceNameHintWithNodes_other": "The name is only shown in this editor. Deleting this space moves its {{count}} nodes to the first space."
  },
  "edge": {
    "bendHandleTitle": "Drag to reshape · Right-click to remove",
    "removePoint": "Remove point"
  },
  "generation": {
    "model": "Model",
    "settings": "Generation settings"
  },
  "imageGeneration": {
    "promptPlaceholder": "Describe the image to generate…",
    "pricePerImage": "{{price}}/img",
    "generateCount_one": "Generate {{count}} image",
    "generateCount_other": "Generate {{count}} images",
    "clearTitle": "Clear the prompt and check every connected image again",
    "referenceLimitExceeded_one": "{{count}} reference image for a model that takes {{max}}. Unplug some, exclude them, or pick another model.",
    "referenceLimitExceeded_other": "{{count}} reference images for a model that takes {{max}}. Unplug some, exclude them, or pick another model.",
    "canCloseWindow": "You can close this window — the images will land on the node.",
    "failed": "The generation failed.",
    "modelRequiresReferences": "This model edits images: connect at least one image node as input, or pick another model.",
    "referencesHint": "Connected images — check the ones to send",
    "count": "Number of images",
    "countSummary_one": "{{count}} image",
    "countSummary_other": "{{count}} images",
    "incompatibleTooManyReferences": "{{max}} references max",
    "incompatibleNeedsSource": "Needs a source image",
    "capReferences": "{{count}} ref.",
    "capEditOnly": "editing",
    "capCount": "1–{{max}} images"
  },
  "videoGeneration": {
    "referenceLimitExceeded_one": "{{count}} reference image for a model that takes {{max}}. Unplug some, switch mode, or pick another model.",
    "referenceLimitExceeded_other": "{{count}} reference images for a model that takes {{max}}. Unplug some, switch mode, or pick another model.",
    "noReferencesSupport": "This model does not accept reference images. Use them as frames or pick another model.",
    "promptPlaceholder": "Describe the video: subject, action, camera movement, sound…",
    "pricePerSecond": "~{{price}}/s",
    "duration": "Duration",
    "durationValue": "{{count}} s",
    "resolution": "Resolution",
    "aspectRatio": "Format",
    "aspectAuto": "Auto",
    "audio": "Generate sound",
    "replaceWarning": "The generated video will replace the current one (it stays in the version history).",
    "generate": "Generate video",
    "clearTitle": "Clear the prompt and reset how connected images are used",
    "canCloseWindow": "You can close this window — the video will land on the node in a few minutes.",
    "failed": "The generation failed.",
    "startFrameName": "start frame",
    "endFrameName": "end frame",
    "problemStartNotSupported": "This model has no start frame: change the image's role or pick another model.",
    "problemEndNotSupported": "This model has no end frame (start only): change the image's role or pick another model.",
    "problemDuplicateFrame": "Only one image can be the start, and one the end.",
    "problemMixed": "Start/End frames and references can't be combined: OpenRouter would ignore the references. Use one or the other.",
    "referenceName": "image {{index}}",
    "modeText": "Text only",
    "modeFrames": "Start → End",
    "modeReferences": "References",
    "slotStart": "Start",
    "slotEnd": "End (optional)",
    "slotEndUnavailable": "End — not available with this model",
    "unusedImages": "Not used:",
    "changeImage": "Change image",
    "pickImage": "Choose an image",
    "clearSlot": "Remove",
    "referencesHint": "Check the images that guide the video",
    "textHint": "Connected images are not sent: the video comes from the prompt alone.",
    "incompatibleNoEnd": "No end frame",
    "incompatibleNoReferences": "No reference images",
    "incompatibleTooManyReferences": "{{max}} references max",
    "capStartEnd": "start+end",
    "capStartOnly": "start only",
    "capReferences": "{{count}} ref.",
    "capAudio": "sound",
    "capAudioAlways": "sound included",
    "capDurations": "{{min}}–{{max}} s",
    "audioAlways": "Always included",
    "audioNone": "No sound",
    "fixRemoveEnd": "Remove the end frame",
    "fixKeepFirst": "Keep the first {{count}}",
    "fixUseModel": "Use {{model}}",
    "modelHasNoReferences": "{{model}} doesn't take reference images.",
    "errorTimeout": "The video took too long to generate and was abandoned. Try again, maybe with a shorter duration.",
    "errorRejected": "The provider refused this request (prompt, images or settings). Adjust them or try another model.",
    "errorTooLarge": "The generated video is too large to be stored. Try a lower resolution or a shorter duration."
  },
  "promptMention": {
    "menuLabel": "Connected images",
    "sentAs": "Sent to the model as “{{name}}”",
    "notSent": "Not sent with this generation (references excluded or not used in this mode).",
    "notConnected": "This image is no longer connected: it won't be sent.",
    "imageName": "image {{index}}",
    "unsentBlocking": "The prompt mentions an image that won't be sent (in red). Reconnect it, change the settings, or remove the mention.",
    "mentionInPrompt": "Mention in the prompt"
  },
  "nodeTypes": {
    "title": {
      "label": "Title",
      "description": "Node for free text labels on the canvas. Supports h1/h2/h3/p heading levels for the whole text. Does not support rich markdown."
    },
    "link": {
      "label": "Link",
      "description": "Node for storing a link."
    },
    "image": {
      "label": "Image",
      "description": "Node for storing an image."
    },
    "blocknote": {
      "label": "Blocknote",
      "description": "Node for storing a rich text document (BlockNote editor)."
    },
    "value": {
      "label": "Value",
      "description": "Node for storing a value (text, number, boolean)."
    },
    "file": {
      "label": "File",
      "description": "Node holding one uploaded file: PDF, Word, Excel, PowerPoint, text, zip…"
    },
    "table": {
      "label": "Table",
      "description": "Node for structured tabular data with typed columns."
    },
    "database": {
      "label": "Database",
      "description": "A collection of records typed by a template: each row has its own life (history, search, a record view)."
    },
    "databaseView": {
      "label": "Database view",
      "description": "A view of a database on the canvas: a filtered table, a board, a gallery or a timeline."
    },
    "app": {
      "label": "App",
      "description": "Node for interactive React apps: prototypes, UI mockups, dashboards, charts, calculators..."
    },
    "audio": {
      "label": "Audio",
      "description": "Node for playing an uploaded audio file, with a saved loop region."
    },
    "video": {
      "label": "Video",
      "description": "Node for playing an uploaded video file."
    },
    "frame": {
      "label": "Frame",
      "description": "Container that groups nodes. Nodes inside a frame move with it and are addressable as a set."
    },
    "board": {
      "label": "Board",
      "description": "Container split into spaces (columns, cells) that arrange the nodes dropped in them: a Kanban, a matrix."
    },
    "custom": {
      "label": "Custom node",
      "description": "A node built from one of your templates."
    }
  },
  "variants": {
    "default": "Default",
    "preview": "Preview",
    "embed": "Embed",
    "carousel": "Carousel",
    "grid": "Grid",
    "title": "Title",
    "player": "Player",
    "compact": "Compact",
    "expanded": "Expanded"
  },
  "video": {
    "generating": "Generating video…",
    "generationStartFailed": "Could not start the video generation",
    "uploadBlockedWhileGenerating": "Upload is disabled while a video is being generated: the generated video would replace it.",
    "generatedWith": "Generated with {{model}}"
  }
}
